export default __webpack_public_path__ + "static/media/863.6b703505.png";